import {
  CREATE_USERS_UPDATE_USER_COUNT,
  CREATE_USERS_UPDATE_CSV,
  CREATE_USERS_FORM_DATA
} from '../constants/action-types'

const defaultState = {
  createUserCount: [1],
  userFormData: [],
  csvData: [],
  requestedBy: '',
  sis_status: { data: [], id: 0, workflow_state: '', loading: true }
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case CREATE_USERS_FORM_DATA: {
      return {
        ...state,
        userFormData: action.payload
      }
    }

    case CREATE_USERS_UPDATE_USER_COUNT: {
      return {
        ...state,
        createUserCount: action.payload
      }
    }

    case CREATE_USERS_UPDATE_CSV: {
      return {
        ...state,
        csvData: action.payload
      }
    }

    default:
      return state
  }
}
